module.exports = __webpack_public_path__ + "static/media/toyota-go-drive.9df9a4bd.png";